import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  timelineHeader: {
    height: 109,
    textAlign: 'center',
    marginTop: -theme.spacing(13),
    zIndex: 101,
    position: 'sticky',
    top: 0,
    paddingTop: 61,
    backgroundColor: theme.palette.brand.white,
  },
  year: { marginTop: -2 },
  currentMonth: {
    textDecoration: 'underline',
    textDecorationColor: theme.palette.brand.orangeDark,
    textDecorationThickness: 2,
    textUnderlineOffset: '3px',
  },
  colorAndFont: {
    color: theme.palette.brand.greenDark,
    fontWeight: 600,
  },
}));

export default function Header({ header, column }) {
  const isCurrentMonth = moment().format('MMM YY') === header.format('MMM YY');
  const classes = useStyles({ isCurrentMonth });
  const month = header.format('MMM');
  const isFirstMonth = column === 2;
  const isJan = month === 'Jan';

  return (
    <div className={classes.timelineHeader}>
      <Typography
        className={
          classes.colorAndFont +
          ' ' +
          (isCurrentMonth ? classes.currentMonth : '')
        }
      >
        {month}
      </Typography>
      {(isFirstMonth || isJan) && (
        <Typography
          variant="subtitle1"
          className={classes.colorAndFont + ' ' + classes.year}
        >
          {header.format('YYYY')}
        </Typography>
      )}
    </div>
  );
}
